import React from "react";
import { Spinner } from "../utils/StyledComponents";

const CustomLoader: React.FC = () => (
  <div style={{ padding: '24px' }}>
    <Spinner />
    <div>Chargement...</div>
  </div>
);

export default CustomLoader;